import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { messages } from "../../config/data";

const TypingDots = () => {
  return (
    <div className="flex gap-1 px-3 py-2 rounded-tl-2xl rounded-bl-2xl rounded-br-2xl w-fit">
      <span className="w-2 h-2 bg-gray-400 rounded-full animate-dot-bounce [animation-delay:-0.2s]" />
      <span className="w-2 h-2 bg-gray-400 rounded-full animate-dot-bounce [animation-delay:-0.1s]" />
      <span className="w-2 h-2 bg-gray-400 rounded-full animate-dot-bounce" />
    </div>
  );
};

const Assistent = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.3 });
  const [visible, setVisible] = useState({});

  useEffect(() => {
    if (inView) {
      const startTimer = setTimeout(() => {
        messages.forEach((msg) => {
          // typing
          setTimeout(() => {
            setVisible((prev) => ({ ...prev, [msg.id]: "typing" }));
          }, msg.delay * 1000);

          // текст
          setTimeout(() => {
            setVisible((prev) => ({ ...prev, [msg.id]: "shown" }));
          }, msg.delay * 1000 + 1500);
        });
      }, 500); // ⏳ задержка 1 сек после того, как блок вошёл в экран

      return () => clearTimeout(startTimer);
    }
  }, [inView]);
  return (
    <div ref={ref} className="relative w-full pt-1 mb-20">
      <div className="flex flex-col items-center w-full">
        <h1 className="text-4xl text-center font-medium bg-gradient-to-r from-[#FC5EB2] to-[#444CE7] mb-5 bg-clip-text text-transparent">
          AI Skincare Assistant
        </h1>
      </div>

      {/* Центрируем всю сцену */}
      <div className="relative w-full h-[500px] flex justify-center items-center">
        {/* Обертка для всей композиции */}
        <div className="relative w-[350px] h-full">
          <img
            loading="lazy"
            className="absolute w-[77%] left-[30px] z-10"
            src="/iPhAssistent.webp"
            alt="iPhone"
          />

          <img
            loading="lazy"
            className="absolute top-[280px] left-[37px] w-[95%] z-20"
            src="/ritualCardAssistent.webp"
            alt="RoutineCard"
          />

          {messages.map((msg, index) => (
            <div key={msg.id}>
              {/* typing dots */}
              {visible[msg.id] === "typing" && (
                <motion.div
                  style={{ willChange: "transform, opacity" }}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className="absolute top-[280px] right-[80px] z-30"
                >
                  <TypingDots />
                </motion.div>
              )}

              {/* само сообщение */}
              {visible[msg.id] === "shown" && (
                <motion.div
                  style={{ willChange: "transform, opacity" }}
                  className={msg.className}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 0.6,
                    ease: "easeOut",
                  }}
                >
                  <p className="text-sm font-normal leading-tight">
                    {msg.text}
                  </p>
                </motion.div>
              )}
            </div>
          ))}

          <svg
            className="absolute top-[220px] left-[180px] z-0"
            width="180"
            height="160"
            viewBox="0 0 163 144"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M28.6817 1.34304C29.4066 0.50967 30.6699 0.421767 31.5033 1.14671C32.3366 1.87167 32.4245 3.13495 31.6996 3.96832L30.1906 2.65568L28.6817 1.34304ZM15.7113 93.571L17.0016 92.0429L15.7113 93.571ZM136.834 142.225C135.732 142.156 134.894 141.206 134.963 140.104L136.087 122.139C136.156 121.037 137.106 120.199 138.208 120.268C139.311 120.337 140.148 121.287 140.079 122.389L139.08 138.358L155.049 139.357C156.151 139.426 156.989 140.376 156.92 141.478C156.851 142.581 155.901 143.418 154.799 143.349L136.834 142.225ZM30.1906 2.65568L31.6996 3.96832C21.8138 15.3327 11.5645 32.0475 7.14553 48.6543C2.72578 65.264 4.22967 81.2583 17.0016 92.0429L15.7113 93.571L14.421 95.0991C-0.0419359 82.8866 -1.33184 64.9574 3.28004 47.6257C7.89267 30.2913 18.5005 13.0469 28.6817 1.34304L30.1906 2.65568ZM15.7113 93.571L17.0016 92.0429C35.5603 107.714 61.573 106.46 86.42 101.355C98.805 98.8101 110.632 95.3731 120.971 92.7417C126.112 91.4334 130.887 90.3246 135.111 89.6555C139.312 88.9901 143.112 88.7341 146.255 89.2198L145.95 91.1964L145.644 93.1729C143.114 92.7819 139.798 92.9629 135.737 93.6062C131.701 94.2456 127.07 95.317 121.958 96.6181C111.792 99.2053 99.729 102.704 87.225 105.273C62.294 110.395 34.534 112.082 14.421 95.0991L15.7113 93.571ZM145.95 91.1964L146.255 89.2198C152.238 90.1444 156.688 92.3986 159.338 95.9506C162.007 99.5269 162.581 104.054 161.566 108.927C159.564 118.549 151.249 130.289 138.282 141.729L136.959 140.229L135.636 138.729C148.387 127.48 155.914 116.458 157.65 108.112C158.506 104.002 157.924 100.744 156.132 98.3427C154.323 95.9174 151.008 94.0018 145.644 93.1729L145.95 91.1964Z"
              fill="url(#paint0_linear_2126_17978)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_2126_17978"
                x1="150.295"
                y1="212.381"
                x2="-3.19964"
                y2="-26.0435"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FC5EB2" stopOpacity="0.1" />
                <stop offset="1" stopColor="#FC5EB2" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default Assistent;
